export default __webpack_public_path__ + "static/Vetri-643e879106206e011bce44edb15468a3.jpg";